import script from "./newsLatestListingVertical.vue?vue&type=script&setup=true&lang=js"
export * from "./newsLatestListingVertical.vue?vue&type=script&setup=true&lang=js"

import "./newsLatestListingVertical.vue?vue&type=style&index=0&id=580b44a7&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-580b44a7"]])

export default __exports__